<template>
    <div>
        <div id="time_bar">
        </div>
    </div>
</template>
<script>
import LanguageService from "../../service/LanguageService";

export default {
    props: {
        acceptanceTimeStart: Object,
        acceptanceTimeEnd: Object,
        timeShift: Array,
    },
    data() {
        return {
            aLang: LanguageService.lang,
            timeViewStart: 0,
            timeViewEnd: 0,
            widthTime: 100,
            backgroundColor: "#80e5f3",
            mData: {
                acceptanceTimeStarts: null,
                acceptanceTimeEnds: null,
                timeShifts: null,
            }
        };
    },
    methods: {
        renderTable(){   
            this.timeViewStart = this.acceptanceTimeStart.hour;
            this.timeViewEnd = this.acceptanceTimeEnd.hour;
            window.$("#time_bar").html(`<div class="table-responsive">`+
                                        `<table class='table table-bordered'>`+
                                            `<tbody>`+
                                                `<tr>`+
                                                    this.renderCollum()+
                                                `</tr>`+
                                            `</tbody>`+
                                        `</table>`+
                                    `</div>`);
        },
        setTimeViewTable(){
            let i = this.timeViewStart;
            while(i>=this.timeViewStart && i<= (this.acceptanceTimeEnd.minute === 0 ? this.timeViewEnd - 1 : this.timeViewEnd)){
                document.getElementById("hour_"+i).style.backgroundColor = this.backgroundColor;
                document.getElementById("hour_"+i).style.width = this.widthTime +"%";
                document.getElementById("hour_"+i).style.height = "100%";
                i++;
            }
            if(this.acceptanceTimeEnd.minute !== 0){
                let widthMinute = (this.acceptanceTimeEnd.minute / 60) * 100;
                document.getElementById("hour_"+this.timeViewEnd).style.width = widthMinute +"%";
            }
        },
        renderCollum(){
            let template = "";
            for (let i = this.timeViewStart - 1; i <= this.timeViewEnd + 1; i++) {
                template += `<td class="p_realetive">` +
                                `<div class="p_absolute" id="hour_`+i+`">`+
                                `</div>`+
                            `</td>`
            }
            return template;
        }
    },
    created: function() {
        setTimeout(async ()=>{
            await this.renderTable();
            this.setTimeViewTable();
        },1000)
    },
    mounted: async function() {
    },
};
</script>
<style scoped>
::v-deep .p_realetive{
    position: relative;
    width: 50px;
    height: 30px;
    padding: 0;
}
.p_absolute{
    position: absolute;
}
</style>